export default "__VITE_ASSET__YeHW4QSW__"